// Categorical chart palette — multi-hue family, auto-adapts to dark mode.
// Used positionally as the FALLBACK for charts that have no semantic/option
// color for a given category (see sliceColors.ts for semantic resolution).
export const CHART_COLORS = [
  "var(--color-chart-1)", // blue
  "var(--color-chart-2)", // green
  "var(--color-chart-3)", // purple
  "var(--color-chart-4)", // amber
  "var(--color-chart-5)", // rose
  "var(--color-chart-6)", // cyan
] as const;

// Neutral grey for "unknown" / "not specified" / un-engaged buckets.
export const CHART_NEUTRAL = "var(--color-chart-neutral)";
